import Icon from '@dtvgo/icon';
import PlayerButton from '../PlayerButton/PlayerButton.js';
import { jsx } from 'react/jsx-runtime';
import '../PlayerButton/PlayerButton.scss';

/* External */

function RewindButton(_ref) {
  var showButton = _ref.showButton,
    handleRewind = _ref.handleRewind,
    tooltip = _ref.tooltip,
    className = _ref.className;
  if (showButton) {
    return /*#__PURE__*/jsx(PlayerButton, {
      className: "dtv-common-c-rewind-button ".concat(className),
      onClick: handleRewind,
      tooltip: tooltip,
      children: /*#__PURE__*/jsx(Icon, {
        name: "rewind-30"
      })
    });
  }
  return null;
}
RewindButton.defaultProps = {
  showButton: true,
  handleRewind: function handleRewind() {},
  tooltip: '',
  className: ''
};

export { RewindButton as default };
//# sourceMappingURL=RewindButton.js.map
